export class ApprobationEntrepriseService {
  constructor(
    private readonly apiUrl: string,
  ) {}

  async soumettreNouvelleDemande(idEntreprise: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des cours:", error);
      throw error;
    }
  }

  async getHistoriqueApprobation(idEntreprise: number) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/demande-approbation`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération des cours:", error);
      throw error;
    }
  }
}
